export default __webpack_public_path__ + "static/media/copy.09213c7f.svg";